import React from 'react'
import { Package } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import IntegrationSelector from './IntegrationSelector'
import UnitTypes from './UnitTypes'

export default function UnitTypesPage() {
  const navigate = useNavigate()
  const { integrationId } = useParams<{ integrationId: string }>()

  const handleIntegrationSelected = (selectedIntegrationId: string) => {
    navigate(`/integrations/${selectedIntegrationId}/unit-types`)
  }

  if (!integrationId) {
    return (
      <IntegrationSelector
        title="Unit Types"
        description="Unit types are configured per integration."
        icon={<Package className="h-6 w-6 text-green-600" />}
        onIntegrationSelected={handleIntegrationSelected}
      />
    )
  }

  return (
    <div className="p-6">
      <UnitTypes />
    </div>
  )
}